
<div class="input-group mb-2">        
  <span class="input-group-text fa-solid fa-magnifying-glass" id="basic-addon1"></span>        
  <input [(ngModel)]="searchBarContent" type="text" class="form-control" placeholder="Nome do App Service">
  <div class="dropdown">
    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      {{selectedContext()}}
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <span (click)="loadTestServerWebApps('Accountant', serviceType())"class="dropdown-item">Accountant</span>          
      <span (click)="loadTestServerWebApps('Organization', serviceType())" class="dropdown-item">Organization</span>          
    </div>
  </div>
</div>      
   
<mat-accordion>      
    <mat-expansion-panel *ngFor="let app of testServerWebApps() | filterWebapps:searchBarContent" class="border-start border-end" >
      <mat-expansion-panel-header class="panel-header">      
        <mat-panel-title class="title">
          <span [innerHTML]="app.name! | highlight:searchBarContent"></span>    
        </mat-panel-title>        
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent >
        <!-- <app-app-settings-form [webAppName]="app.name!">
        </app-app-settings-form> -->
      </ng-template>
    </mat-expansion-panel>   
</mat-accordion>

  <div class="mt-3" id="spinner" *ngIf="dataStatus.loading()">
    <app-progress-spinner></app-progress-spinner>
  </div>